import React from "react";
import { useNavigate } from "react-router-dom";

export default function LegalPage({ user, onLogout }) {
  const navigate = useNavigate();
  const s = {
    root: { fontFamily: "'Segoe UI', Arial, sans-serif", background: "transparent", color: "#0f172a", minHeight: "100vh" },
    nav: { padding: "16px 40px", borderBottom: "1px solid rgba(59,130,246,0.15)", background: "rgba(238,242,251,0.95)", backdropFilter: "blur(12px)" },
    main: { maxWidth: 700, margin: "0 auto", padding: "48px 20px" },
    logo: { fontSize: 20, fontWeight: 800, color: "#0f172a", cursor: "pointer" },
    logoAccent: { color: "#3b82f6" },
    title: { fontSize: 32, fontWeight: 800, color: "#0f172a", marginBottom: 8 },
    sub: { fontSize: 16, color: "#64748b", marginBottom: 40 },
    card: { background: "rgba(255,255,255,0.75)", border: "1px solid rgba(59,130,246,0.12)", borderRadius: 16, padding: "22px 24px", marginBottom: 12, cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", backdropFilter: "blur(8px)", boxShadow: "0 2px 8px rgba(59,130,246,0.06)", transition: "box-shadow 0.2s" },
    cardLeft: {},
    cardTitle: { fontSize: 17, fontWeight: 700, color: "#1e293b", marginBottom: 4 },
    cardDesc: { fontSize: 13, color: "#64748b" },
    arrow: { fontSize: 20, color: "#94a3b8" },
    footer: { marginTop: 48, fontSize: 13, color: "#94a3b8", textAlign: "center" },
  };

  const docs = [
    { path: "/legal/privacy", title: "Privacy Policy", desc: "How we collect, use, and protect your personal information" },
    { path: "/legal/terms", title: "Terms of Service", desc: "Rules and conditions for using the iTrust Secure platform" },
    { path: "/legal/refunds", title: "Refund & Dispute Policy", desc: "How refunds work and how disputes are handled" },
  ];

  return (
    <div style={s.root}>
      <nav style={s.nav}>
        <div style={s.logo} onClick={() => navigate("/")}>
          i<span style={s.logoAccent}>Trust Secure</span>
        </div>
      </nav>
      <div style={s.main}>
        <div style={s.title}>Legal</div>
        <div style={s.sub}>Policies and agreements governing your use of iTrust Secure</div>
        {docs.map(doc => (
          <div
            key={doc.path}
            style={s.card}
            onClick={() => navigate(doc.path)}
            onMouseEnter={e => e.currentTarget.style.boxShadow = "0 6px 20px rgba(59,130,246,0.15)"}
            onMouseLeave={e => e.currentTarget.style.boxShadow = "0 2px 8px rgba(59,130,246,0.06)"}
          >
            <div style={s.cardLeft}>
              <div style={s.cardTitle}>{doc.title}</div>
              <div style={s.cardDesc}>{doc.desc}</div>
            </div>
            <div style={s.arrow}>›</div>
          </div>
        ))}
        <div style={s.footer}>
          iTrust Secure LLC · Florida, USA · founder@itrustsecure.com
        </div>
      </div>
    </div>
  );
}